// ─── Bleeding Colour Maps ─────────────────────────────────────────────────────

export type BleedingColourKey =
  | "dark_red"
  | "bright_red"
  | "brown"
  | "yellowish"
  | "clear";

export const BLEEDING_COLOUR_MAP: Record<BleedingColourKey, string> = {
  dark_red: "#912A23",
  bright_red: "#BD4138",
  brown: "#C46C5D",
  yellowish: "#FFBBA6",
  clear: "#FFFFFF",
};

export const BLEEDING_COLOUR_LABEL_MAP: Record<BleedingColourKey, string> = {
  dark_red: "Dark red",
  bright_red: "Bright red",
  brown: " Brown",
  yellowish: "Yellowish",
  clear: "White or clear",
};

export const DEFAULT_BLEEDING_BG = "#C0C0C0";

export const getBleedingBgColor = (colour: string | undefined): string => {
  if (!colour) return DEFAULT_BLEEDING_BG;
  return BLEEDING_COLOUR_MAP[colour as BleedingColourKey] ?? DEFAULT_BLEEDING_BG;
};

export const getBleedingColourLabel = (colour: string | undefined): string => {
  if (!colour) return "N/A";
  return BLEEDING_COLOUR_LABEL_MAP[colour as BleedingColourKey] ?? "Unknown";
};

export const capitalizeFlow = (flow: string | undefined): string => {
  if (!flow) return "N/A";
  return flow.charAt(0).toUpperCase() + flow.slice(1) + " flow";
};

export const capitalizeClots = (clots: string | undefined): string => {
  if (!clots) return "N/A";
  return clots.charAt(0).toUpperCase() + clots.slice(1) + " clots";
};
